export default __webpack_public_path__ + "static/media/wi-night-snow-thunderstorm.89a6ac9d.svg";